// dbo.AuditLogActions
export enum AuditLogActions {
  APPROVE_ONBOARDING = 1,
  DECLINE_ONBOARDING = 2,
  UPDATE_ONBOARDING = 3,
  ENABLE_ONBOARDING = 4,
  DISABLE_ONBOARDING = 5,
  EXPORT_TRANSACTIONS = 6,
  EXPORT_FILES = 7,
  CREATE_POS = 8,
  UPDATE_POS = 9,
  ENABLE_ACCOUNT = 10,
  DISABLE_ACCOUNT = 11,
  UPDATE_ACCOUNT = 12,
  ENABLE_ENTITY = 13,
  DISABLE_ENTITY = 14,
  CREATE_MID = 15,
  UPDATE_MID = 16,
  ASSIGN_MID = 17,
  UNASSIGN_MID = 18,
  ENABLE_MID = 19,
  DISABLE_MID = 20,
  LOGIN = 21,
  LOGOUT = 22,
  AUB_APPROVE_ONBOARDING = 23,
  AUB_DECLINE_ONBOARDING = 24,
  UB_APPROVE_ONBOARDING = 25,
  UB_DECLINE_ONBOARDING = 26,
  MAYA_APPROVE_ONBOARDING = 27,
  MAYA_DECLINE_ONBOARDING = 28,
  CREATE_PAYMENT_LINK = 29
}
